export var FlatGroundPointType;
(function (FlatGroundPointType) {
    FlatGroundPointType["UNDER"] = "under";
    FlatGroundPointType["ABOVE"] = "above";
    FlatGroundPointType["INTERSECTION"] = "intersection";
})(FlatGroundPointType || (FlatGroundPointType = {}));
export const DEFAULT_FLAT_GROUND_LABEL_COLOR = "#F283E5";
//# sourceMappingURL=flatground-info-interface.js.map